var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-row',[_c('a-button',{on:{"click":function($event){return _vm.userExit()}}},[_vm._v(" Exit ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }